export default __webpack_public_path__ + "static/media/Rockies.1f6d5405.png";